import { useState, useEffect } from "react";
import { KeyRound, Copy, Trash2, Plus } from "lucide-react";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";

export const WebsiteKeys = () => {
  const [keys, setKeys] = useState([]);
  const [name, setName] = useState("Doggy Demo website");
  const [fresh, setFresh] = useState(null);
  const [busy, setBusy] = useState(false);
  const load = () => api.get("/settings/website-keys").then(({ data }) => setKeys(data)).catch(() => {});
  useEffect(() => { load(); }, []);
  const create = async () => {
    setBusy(true);
    try { const { data } = await api.post("/settings/website-keys", { name }); setFresh(data); load(); toast.success("Key created"); }
    catch (err) { toast.error(formatApiError(err.response?.data?.detail)); } finally { setBusy(false); }
  };
  const revoke = async (k) => {
    if (!window.confirm(`Revoke "${k.name}"? Any website using it will stop receiving products.`)) return;
    try { await api.delete(`/settings/website-keys/${k.id}`); toast.success("Key revoked"); if (fresh?.id === k.id) setFresh(null); load(); }
    catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
  };
  const copy = () => { navigator.clipboard?.writeText(fresh.key); toast.success("Copied"); };
  return (
    <div className="bg-white border border-border rounded-2xl p-6 max-w-4xl" data-testid="website-keys-settings">
      <div className="flex items-center gap-2 mb-1"><KeyRound className="text-brand" size={22} /><h3 className="font-heading text-xl font-bold">Website product feed</h3></div>
      <p className="text-sm text-muted-foreground mb-4">Read-only keys that let your separate website load the product list. Keep keys on your website's server, never in browser code.</p>
      <div className="flex flex-wrap gap-2">
        <input data-testid="website-key-name" value={name} onChange={(e) => setName(e.target.value)} className="inp flex-1 min-w-[200px]" placeholder="Key name" />
        <button onClick={create} disabled={busy} data-testid="website-key-create" className="h-11 px-5 rounded-xl bg-brand text-white font-semibold flex items-center gap-2 active:scale-95 disabled:opacity-50"><Plus size={17} />Create key</button>
      </div>
      {fresh && (
        <div className="mt-4 p-4 rounded-xl border border-amber-300 bg-amber-50" data-testid="website-key-fresh">
          <p className="text-sm font-semibold text-amber-800">Copy this key now. It will not be shown again.</p>
          <div className="flex items-center gap-2 mt-2"><code className="flex-1 text-xs break-all bg-white border border-amber-200 rounded-lg p-2" data-testid="website-key-value">{fresh.key}</code>
            <button onClick={copy} data-testid="website-key-copy" className="h-9 w-9 rounded-lg border border-amber-300 flex items-center justify-center"><Copy size={16} /></button></div>
        </div>
      )}
      <div className="mt-4 divide-y divide-zinc-100" data-testid="website-key-list">
        {keys.length === 0 && <p className="text-sm text-zinc-400 py-2">No keys yet.</p>}
        {keys.map((k) => (
          <div key={k.id} className="flex items-center gap-3 py-2.5 text-sm" data-testid={`website-key-row-${k.id}`}>
            <div className="flex-1 min-w-0"><p className="font-semibold">{k.name} {k.revoked && <span className="ml-1 text-[11px] text-red-500 font-bold uppercase">Revoked</span>}</p>
              <p className="text-xs text-zinc-400 font-mono">{k.preview} · created {k.created_at?.slice(0, 10)} · {k.last_used_at ? `last used ${k.last_used_at.slice(0, 16).replace("T", " ")}` : "never used"}</p></div>
            {!k.revoked && <button onClick={() => revoke(k)} data-testid={`website-key-revoke-${k.id}`} className="h-9 px-3 rounded-lg border border-zinc-200 text-red-600 font-semibold flex items-center gap-1.5"><Trash2 size={15} />Revoke</button>}
          </div>
        ))}
      </div>
    </div>
  );
};
